import VoiSelectorOverlay from '~/viewportGrid/adapters/engine/overlays/VoiSelector';
import type { Environment } from '~/engine/data/Environment';
import { RenderAdapter } from '~/viewportGrid/adapters/types';
import { usePlaneViewHostedBy } from '../usePlaneViewHostedBy';

interface TileVoiMountProps {
    renderer: RenderAdapter;
    /** The Environment whose tiles host the shared VOI box; undefined hides it. */
    voiHost: Environment | undefined;
}

/**
 * Mounts the shared VOI box over one grid tile, driven by the tile's
 * engine view (the same fence-legal downcast as TileCrosshairMount), and
 * only on a tile of the Environment that hosts the box. The overlay owns
 * projection, seeding and handle editing; this mount owns nothing but the
 * gate. Renders nothing for non-engine renderers (the mock adapters).
 */
export default function TileVoiMount({ renderer, voiHost }: TileVoiMountProps) {
    const view = usePlaneViewHostedBy(renderer, voiHost);
    if (!view) {
        return null;
    }
    return <VoiSelectorOverlay view={view} />;
}
